import { useEffect, useState, useCallback, useRef, ReactNode } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from "../hook";
import React from "react";
import Cookies from 'js-cookie';
import { login, logout, updateIsRequest, updateUserData } from "../slice/authSlice";
import Loader from '../Ui/Loader/Loader';
import { deleteRoleState, saveRoleState } from '../slice/roleMatrix';
import {getUserInfo, refreshToken } from '../../common/api/authApi';

interface IRedirectAuthorization {
  children: ReactNode;
}

export const RedirectAuthorization: React.FC<IRedirectAuthorization> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const userData = useAppSelector(state => state.auth.userData);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const refresh_token = Cookies.get("refresh_token");
  const encodedRole = Cookies.get("role");
  const role = encodedRole ? decodeURIComponent(encodedRole) : null;
  const access_token = Cookies.get("access_token");

  const clearCookies = useCallback(() => {
    console.log('Clearing cookies');
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("token_expiry");
    Cookies.remove("role");
    Cookies.remove("SESSION", { path: "/", domain: ".edge-apps.com" });
    Cookies.remove("refresh_token", { path: "/", domain: ".edge-apps.com" });
  }, []);

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      console.log('checkAuth started:', {
        access_token: !!access_token,
        refresh_token: !!refresh_token,
        userData,
        role,
        path: location.pathname
      });

      if (!access_token && !refresh_token) {
        console.log('No tokens found, redirecting to auth');
        clearCookies();
        dispatch(deleteRoleState);
        dispatch(logout());
        if (isMounted) {
          navigate('/auth');
        }
        return;
      }

      // Проверяем, есть ли у нас данные пользователя
      const hasUserData = userData && userData.id && userData.login;
      
      if (!hasUserData) {
        console.log('No userData, fetching user info');
        try {
          const response = await getUserInfo();
          console.log('getUserInfo response:', response);
          
          if (response && isMounted) {
            console.log('Dispatching user data to Redux:', response);
            dispatch(updateUserData(response));
            dispatch(login());
          } else {
            console.error('getUserInfo returned null or undefined');
            throw new Error('Failed to get user data');
          }
        } catch (error) {
          console.error('getUserInfo error:', error);
          if (isMounted) {
            dispatch(deleteRoleState);
            dispatch(logout());
            clearCookies();
            navigate('/auth');
          }
        }
      }

      if (isMounted) {
        setIsLoading(false);
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, [access_token, refresh_token, dispatch, navigate, clearCookies, location.pathname]);

  if (isLoading) {
    console.log('Loading state, showing loader');
    return <Loader/>;
  }

  if (!access_token || !refresh_token) {
    console.log('No tokens, redirecting to auth');
    return <Navigate to="/auth" />;
  }

  if (!role) {
    console.log('No role, redirecting to auth');
    return <Navigate to="/auth" />;
  }

  if (!userData?.id || !userData?.login) {
    console.log('No user data, redirecting to auth');
    return <Navigate to="/auth" />;
  }

  console.log('All checks passed, rendering children');
  return <>{children}</>;
};